import { useReduxState } from 'hooks';
import api from 'api';
import { Alert, ConfirmButton } from 'components/common';

import type { GetAchievementGroupCompletionsRes } from 'shared-types/responses';

interface Props {
  groupCompletion: GetAchievementGroupCompletionsRes['groupCompletions'][number];
  updateGroups: () => Promise<void>;
}

const AchievementGroupOfUsersArchive = ({
  groupCompletion,
  updateGroups
}: Props) => {
  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const archive = async () => {
    await api.delete(
      `/admin/achievements/${achievement.id}/group-completions` +
        (groupCompletion ? `/${groupCompletion.achievementData.id}` : '') +
        '?archiveCompletion=true'
    );

    await updateGroups();
    return true;
  };

  return (
    <ConfirmButton
      actionCategory="danger"
      actionText={messages.commonConfirm}
      buttonCategory="lighter"
      buttonIcon="archive"
      buttonSize="header"
      buttonIsDropdown={Boolean(groupCompletion)}
      buttonText={messages.achievementGroupConversationArchive}
      confirmText={
        <div>
          <Alert
            style={{ marginBottom: 15 }}
            text={`${messages.commonActionIsPermanent}. ${messages.achievementGroupConversationArchiveInfo}`}
            type="warning-light"
          />

          {messages.achievementGroupConversationArchiveConfirm}
        </div>
      }
      confirmTitle={messages.achievementGroupConversationArchive}
      onConfirm={archive}
      successMessage={messages.achievementGroupConversationArchiveSuccess}
    />
  );
};

export default AchievementGroupOfUsersArchive;
